
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ressort/[id]",
      function () {
        return require("private-next-pages/ressort/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ressort/[id]"])
      });
    }
  